import { YoutubeCard } from '../../Widget/Social/YoutubeCard';
import { YoutubePost } from '../../Widget/Social/types';

export const YoutubeNews = ({
  youtubeNews,
}: {
  youtubeNews: YoutubePost[];
}) => (
  <div className={'grid gap-4 grid-cols-2 p-4'}>
    {youtubeNews.map((item) => (
      <YoutubeCard post={item} key={item.id} />
    ))}
  </div>
);
